import './LightsControl.css'
import { Button } from '@mui/material'
// Components
import IonicPageWrapper from '../../components/IonicPageWrapper/IonicPageWrapper'
// ICONs & SVGs
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import lightIcon from '../../imgs/light_img.svg'

import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

function LightsControl() {
    const isloggedin = localStorage.getItem("loggedIn");
    const history = useHistory();
    useEffect(() => {
        if(!isloggedin)
        {
            history.push('/login');
            window.location.reload(); 
        }
    }, []);
    const onBackClick = () => { }

    return (
        <IonicPageWrapper headerTitle='Lights' onBackClick={onBackClick} >
            <div id="lightsControl">
                <div className="lightsControl_cardCont">
                    <LightsCOntrolCard />
                    <LightsCOntrolCard />
                    <LightsCOntrolCard />
                    <LightsCOntrolCard />
                </div>
            </div>
        </IonicPageWrapper>
    )
}

export default LightsControl

const LightsCOntrolCard = () => (
    <div className="lightsControl_card">
        <PowerSettingsNewIcon className='lightsControl_card_closeIcon' />

        <section className='lightsControl_card_content'>
            <img src={lightIcon} alt="" />
            <p>20 Devices</p>
        </section>

        <section className="lightsControl_card_btnsCont">
            <Button variant='contained' sx={{ backgroundColor: 'red !important' }} />
            <Button variant='contained' sx={{ backgroundColor: 'yellow !important' }} />
            <Button variant='contained' sx={{ backgroundColor: '#fff !important' }} />
        </section>
    </div>
)